import { render, staticRenderFns } from "./Manage-Designation.vue?vue&type=template&id=2a58ac92"
import script from "./Manage-Designation.vue?vue&type=script&lang=js"
export * from "./Manage-Designation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports